import React, { Suspense, useRef } from 'react';
import { SpinnerSvg } from '../assets/icon/spinner';
import { SvgProps } from '../types/icon';
import styled from "@emotion/styled"

// 원래는 css였으나 각 로딩창의 css는 독립적이여야 하며 마운트 되는동안 각 모듈의 shadow를 찾을수가 없음.
const SpinnerBackground = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
`;
const SpinnerIcon = styled.div`
  margin-top: 30vh;
`


export const FullscreenSpinner = ({
  backgroundColor = 'transparent',
  size = 100,
  color,
}: SvgProps) => {
  return (
    <SpinnerBackground style={{ backgroundColor }}>
      <SpinnerIcon
        style={{ width: size, height: size }}
      >
        <SpinnerSvg size={size} color={color} />
      </SpinnerIcon>
    </SpinnerBackground>
  );
};
